import DevisePasswordsNew from './DevisePasswordsNew'

export default DevisePasswordsNew
